export const GLOBAL_LABELS = 'global';

// global placeRewards
export const lblBonusPointsDaysLeft = 'lbl_bonus_points_daysLeft';
export const lblBonusPointsBonusPointsDay = 'lbl_bonus_points_bonusPointsDay';

// global bonusPoints
export const lblBonusPointsUsedOn = 'lbl_bonusPoints_usedOn';
export const lblBonusPointsFutureUse = 'lbl_bonusPoints_futureUse';
export const lblBonusPointsCtaApplied = 'lbl_bonusPoints_ctaApplied';
export const lblBonusPointsCtaApply = 'lbl_bonusPoints_ctaApply';
export const lblBonusPointsPlaceRewardsDay = 'lbl_bonusPoints_placeRewardsDay';
export const lblBonusPointsApplyAnyDay = 'lbl_bonusPoints_applyAnyDay';
export const lblBonusPointsMsg = 'lbl_bonusPoints_msg';
export const lblBonusPointsMyRewardsUsedAll = 'lbl_bonusPoints_myRewardsUsedAll';

const BonusPointsDaysLabels = {
  global: {
    placeRewards: {
      [lblBonusPointsDaysLeft]: 'You have {0} day left. ',
      [lblBonusPointsBonusPointsDay]: 'BONUS POINTS DAY',
    },
    bonusPoints: {
      [lblBonusPointsUsedOn]: 'USED ON',
      [lblBonusPointsFutureUse]: 'AVAILABLE FOR FUTURE USE',
      [lblBonusPointsCtaApplied]: 'Applied to Order',
      [lblBonusPointsCtaApply]: 'AVAILABLE TODAY!',
      [lblBonusPointsPlaceRewardsDay]: 'DAY',
      [lblBonusPointsApplyAnyDay]: 'Apply to any day. Your choice!',
      [lblBonusPointsMsg]:
        'My Place Rewards members get double points…Use your My Place Rewards Credit Card to get triple!',
      [lblBonusPointsMyRewardsUsedAll]: "You've used all your available Bonus Points Days.",
    },
  },
};
export default BonusPointsDaysLabels;
